import React, { useState } from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";
import FileDownload from "components/common/FileDownload";
import DeleteDocumentConfirmationModal from "components/orders/DeleteDocumentConfirmationModal";
import { OrderApi } from "services/apis/OrderApi";
import { handleError } from "services/util/ApiUtil";
import { showInfoNotification } from "components/framework/notification/NotificationUtil";
import { getFormattedUtcDate } from "services/util/DateUtil";
import { OrderRequestTypes } from "services/apis/types/port/OrderRequestType";

export default function Document(props) {
  const [documentUrl, setDocumentUrl] = useState<string | undefined>(undefined);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const location = window.location.href;
  const pageInPortIn = location.includes("PortIn");

  
  // Attribution Resolution
  

  const resolveDisplayUploader = () => {
    const uploaderType = props.document?.uploaderType;
    const viewer = props.viewerContext;
    const name = props.document?.uploadBy;

    if (uploaderType === "system" || name === "System") return "System";


    // Matrix rules:
    if (viewer === "whiteLabelCustomer" || viewer === "wholesaleCustomer") {
      if (uploaderType === "pcAdmin" || uploaderType === "workQueue") {
        return "Staff";
      }
    }

    return name; // default: show actual name
  };

  const deleteFile = () => {
    if (props.orderId && props.document.documentId) {
      setLoading(true);

      OrderApi.deleteDocument(props.orderId, props.document.documentId)
        .then(() => {
          props.deleteDocument(props.document);
          showInfoNotification(intl.formatMessage({ id: "orders.documents.deleteSuccessfulMessage" }));
          setShowDeleteModal(false);
        })
        .catch(handleError)
        .finally(() => setLoading(false));
    } else {
      props.deleteDocument(props.document);
      setShowDeleteModal(false);
    }
  };

  const downloadFile = () => {
    if (!props.document.documentId || !props.orderId) return;

    OrderApi.getDocument(props.orderId, props.document.documentId)
      .then((blob) => {
        if (blob instanceof Blob) {
          setDocumentUrl(URL.createObjectURL(blob));
        }
      })
      .catch(handleError);
  };

  return (
    <div className="d-flex justify-content-between">
      <span>
        <i className="far fa-file-upload" />

        {documentUrl && (
          <FileDownload
            url={documentUrl}
            fileName={props.document.fileName}
            callback={() => setDocumentUrl(undefined)}
          />
        )}

        <small
          className={classNames("ml-2 word-break", {
            "text-underline cursor-pointer": props.document.documentId
          })}
          onClick={() => !props.disabled && downloadFile()}
        >
          {props.document.fileName}
        </small>

        {/* Uploader attribution */}
        {(pageInPortIn === false && props.orderRequestType !== OrderRequestTypes.CSROnly) && (
          <div>
            <small className="ml-2" style={{ color: "#808080e0", fontSize: "70%" }}>
              {
                props.document.uploadBy ? (
                  <>
                    Added By <b>{resolveDisplayUploader()}</b> on{" "}
                    <b>{getFormattedUtcDate(props.document.uploadDate)}</b>
                  </>
                ) : (
                  <>Added on <b>{getFormattedUtcDate(props.document.uploadDate)}</b></>
                )
              }
            </small>
          </div>
        )}
      </span>

      <i
        className={classNames("fa fa-trash", {
          "text-danger cursor-pointer": !props.document.deleteDisabled
        })}
        onClick={() => !props.disabled && !props.document.deleteDisabled && setShowDeleteModal(true)}
      />

      {showDeleteModal && (
        <DeleteDocumentConfirmationModal
          documentName={props.document.fileName}
          showLoadingIndicator={loading}
          confirmCallback={deleteFile}
          closeModal={() => setShowDeleteModal(false)}
        />
      )}
    </div>
  );
}
